var _defs, _path, _path2, _polygon, _path3, _path4, _path5, _path6, _path7, _path8, _line, _path9, _circle, _path10, _circle2, _circle3, _path11, _circle4, _path12, _circle5, _path13, _circle6, _circle7, _circle8, _path14, _path15, _circle9, _path16, _path17, _circle10, _path18, _path19, _path20, _path21, _path22, _path23, _polygon2, _path24, _path25, _path26, _path27, _path28, _path29, _line2, _path30, _polygon3, _polygon4, _rect, _rect2, _text, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgObj100(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1548.6 264.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#50bd86;}.cls-2{fill:#434341;}.cls-3,.cls-7{fill:#fff;}.cls-4{fill:#ffdc00;}.cls-5{fill:#aae2c2;}.cls-6{fill:#ffbe09;}.cls-7{font-size:35px;font-family:CloserText-Black, Closer Text;font-weight:800;letter-spacing:0.05em;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M745.92,246.35A91.36,91.36,0,1,0,654.51,155,91.38,91.38,0,0,0,745.92,246.35Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M745.92,248.15A93.16,93.16,0,1,1,839.13,155,93.29,93.29,0,0,1,745.92,248.15Zm0-182.71A89.56,89.56,0,1,0,835.52,155,89.69,89.69,0,0,0,745.92,65.44Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "846.64 80.23 823.47 78.68 821.57 55.16 854.85 21.89 856.58 45.23 879.92 46.95 846.64 80.23"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M847.33,82.09,821.8,80.37l-2.09-25.89,36.65-36.65,1.9,25.71L884,45.45ZM825.14,77l20.8,1.4,29.92-29.92-21-1.55-1.56-21L823.43,55.85Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M745.92,227.3A72.31,72.31,0,1,0,673.57,155,72.33,72.33,0,0,0,745.92,227.3Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M745.92,205.39A50.4,50.4,0,1,0,695.49,155,50.4,50.4,0,0,0,745.92,205.39Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M745.92,207.19A52.2,52.2,0,1,1,798.15,155,52.27,52.27,0,0,1,745.92,207.19Zm0-100.79A48.6,48.6,0,1,0,794.54,155,48.67,48.67,0,0,0,745.92,106.4Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M745.92,180.25A25.26,25.26,0,1,0,720.64,155,25.25,25.25,0,0,0,745.92,180.25Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M745.92,182.06A27.07,27.07,0,1,1,773,155,27.1,27.1,0,0,1,745.92,182.06Zm0-50.52A23.46,23.46,0,1,0,769.39,155,23.49,23.49,0,0,0,745.92,131.54Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 746.5,
    y1: 154.47,
    x2: 855.86,
    y2: 45.12
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M746.5,156.28a1.81,1.81,0,0,1-1.27-3.08L854.58,43.84a1.8,1.8,0,1,1,2.55,2.55L747.78,155.75A1.84,1.84,0,0,1,746.5,156.28Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 271.81,
    cy: 228.78,
    r: 9.45
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M154.79,196.82a17.56,17.56,0,0,0-24.78,0l-7.53-7.53a28.2,28.2,0,0,1,39.85,0Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 189.13,
    cy: 66.68,
    r: 9.45
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 1412.91,
    cy: 159.04,
    r: 10.09
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1342.57,216.35a30.72,30.72,0,0,1-42.84,7l6.79-9.43a19.1,19.1,0,0,0,26.63-4.34Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 1166.67,
    cy: 44.47,
    r: 10.09
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1318,66.09A30.13,30.13,0,0,1,1287.91,36h11.38A18.73,18.73,0,0,0,1318,54.71Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 1303.04,
    cy: 112.16,
    r: 10.09
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1466,225.09A30.13,30.13,0,0,1,1435.91,195h11.38A18.73,18.73,0,0,0,1466,213.71Z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 1450.6,
    cy: 65.08,
    r: 10.09
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 958.28,
    cy: 24.81,
    r: 10.09
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 494.49,
    cy: 46.35,
    r: 9.45
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M868,247.69A30.72,30.72,0,0,1,837.31,217h11.61A19.1,19.1,0,0,0,868,236.08Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M495.68,231.71a17.5,17.5,0,0,0-21.89-11.6l-3.13-10.19a28.18,28.18,0,0,1,35.22,18.65Z"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 347.54,
    cy: 186.13,
    r: 9.45
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M333,59.18A28.21,28.21,0,0,1,304.82,31h10.66A17.54,17.54,0,0,0,333,48.52Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M246,150.16l-7.54-7.54a17.49,17.49,0,0,0,0-24.77l7.54-7.54a28.16,28.16,0,0,1,0,39.85Z"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 616.98,
    cy: 206.26,
    r: 9.45
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M418.81,140a17.51,17.51,0,0,0-21.89-11.59l-3.13-10.19A28.17,28.17,0,0,1,429,136.86Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M607.53,60.09a28.21,28.21,0,0,1-28.18-28.18H590a17.54,17.54,0,0,0,17.52,17.52Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M534.35,159l-7.54-7.53a17.5,17.5,0,0,0,0-24.78l7.54-7.53a28.15,28.15,0,0,1,0,39.84Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M97.46,92.93l5,9.41A17.5,17.5,0,0,0,95.23,126l-9.41,5A28.16,28.16,0,0,1,97.46,92.93Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M745.94,248.2a92,92,0,1,0-92.08-92A92.06,92.06,0,0,0,745.94,248.2Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M745.94,250a93.85,93.85,0,1,1,93.9-93.85A94,94,0,0,1,745.94,250Zm0-184.06a90.21,90.21,0,1,0,90.27,90.21A90.34,90.34,0,0,0,745.94,66Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "847.4 80.86 824.07 79.29 822.15 55.61 855.68 22.09 857.42 45.59 880.93 47.34 847.4 80.86"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M848.11,82.73,822.39,81l-2.11-26.08L857.19,18l1.92,25.9L885,45.82Zm-22.36-5.14,21,1.4,30.14-30.14-21.12-1.56-1.56-21.12L824,56.3Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M745.94,229a72.84,72.84,0,1,0-72.88-72.84A72.86,72.86,0,0,0,745.94,229Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M745.94,206.94a50.77,50.77,0,1,0-50.79-50.77A50.78,50.78,0,0,0,745.94,206.94Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M745.94,208.76a52.59,52.59,0,1,1,52.62-52.59A52.66,52.66,0,0,1,745.94,208.76Zm0-101.54a49,49,0,1,0,49,48.95A49,49,0,0,0,745.94,107.22Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M745.94,181.62a25.45,25.45,0,1,0-25.45-25.45A25.45,25.45,0,0,0,745.94,181.62Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M745.94,183.43a27.26,27.26,0,1,1,27.28-27.26A27.29,27.29,0,0,1,745.94,183.43Zm0-50.89a23.63,23.63,0,1,0,23.65,23.63A23.66,23.66,0,0,0,745.94,132.54Z"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 746.53,
    y1: 155.65,
    x2: 856.69,
    y2: 45.49
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M746.53,157.46a1.78,1.78,0,0,1-1.28-.53,1.82,1.82,0,0,1,0-2.57L855.41,44.2a1.82,1.82,0,0,1,2.57,0,1.84,1.84,0,0,1,0,2.57L747.82,156.93A1.8,1.8,0,0,1,746.53,157.46Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "771 57.86 654.72 112.58 636.46 73.76 671.69 74.24 689.36 35.27 730.64 46.5 752.73 19.05 771 57.86"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "709.58 86.76 659.07 110.53 644.74 80.08 675.35 80.49 690.71 46.64 709.58 86.76"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 889.52,
    y: 190.56,
    width: 257,
    height: 34,
    rx: 17
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 898.52,
    y: 196.06,
    width: 237,
    height: 23,
    rx: 11.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(1156.67 219.01)"
  }, "100%")), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M903.8,72.06a17.15,17.15,0,0,1,23.44,0,16.12,16.12,0,0,1,4.59,11.84,16.1,16.1,0,0,1-4.59,11.83,17.12,17.12,0,0,1-23.44,0,16.1,16.1,0,0,1-4.59-11.83A16.12,16.12,0,0,1,903.8,72.06Zm6.81,17.39a6.59,6.59,0,0,0,9.79,0,8.92,8.92,0,0,0,0-11.11,6.59,6.59,0,0,0-9.79,0,9,9,0,0,0,0,11.11Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M952.22,68.15a13.61,13.61,0,0,1,8.59,2.54,8,8,0,0,1,3.29,6.59,8.63,8.63,0,0,1-2.52,6.12A8.49,8.49,0,0,1,965,90.29,8.19,8.19,0,0,1,961.64,97a13.82,13.82,0,0,1-8.75,2.6h-16V68.15Zm-5.85,8v3.83h5.76a2.7,2.7,0,0,0,1.8-.57A1.71,1.71,0,0,0,954.6,78a1.66,1.66,0,0,0-.67-1.35,2.8,2.8,0,0,0-1.8-.54Zm0,11.3v4.22h6.48a2.89,2.89,0,0,0,1.91-.58,2,2,0,0,0,.7-1.58,1.87,1.87,0,0,0-.72-1.46,2.86,2.86,0,0,0-1.89-.6Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M967.2,90.92a9.07,9.07,0,0,0,3.65.71c3,0,4.45-1.43,4.45-4.31V68.15h9.54V88.8a10.85,10.85,0,0,1-3.46,8.37,12.83,12.83,0,0,1-9,3.2q-3.74,0-5.13-1Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M990.74,68.15H1015v8h-14.81v3.74H1013v7.74h-12.74v4h15.26v8H990.74Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1038.17,76.11V99.64h-9.5V76.11h-9.49v-8h28.48v8Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1052.12,68.15h9.49V99.64h-9.49Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1065.79,68.15h10.35l6.93,19.21,6.8-19.21h10.35L1087.3,99.64h-8.5Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1106,72.06a17.16,17.16,0,0,1,23.45,0,16.12,16.12,0,0,1,4.59,11.84,16.1,16.1,0,0,1-4.59,11.83,17.13,17.13,0,0,1-23.45,0,16.1,16.1,0,0,1-4.59-11.83A16.12,16.12,0,0,1,1106,72.06Zm6.82,17.39a6.19,6.19,0,0,0,4.88,2.18,6.26,6.26,0,0,0,4.91-2.18,9,9,0,0,0,0-11.11,6.26,6.26,0,0,0-4.91-2.18,6.19,6.19,0,0,0-4.88,2.18,9,9,0,0,0,0,11.11Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M898.4,153.64l13-31.49h8.51l12.91,31.49H922.47l-1.53-4.36H910.32l-1.57,4.36Zm19.71-12.32-2.43-6.89-2.48,6.89Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M937.05,122.15h9.5v23.48h14.22v8H937.05Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M985.47,135.42a7.2,7.2,0,0,0,.23-1.75,3,3,0,0,0-1.53-2.5,7.77,7.77,0,0,0-9.23,1.17,8.92,8.92,0,0,0,0,11.16,6.7,6.7,0,0,0,5.22,2.13,6,6,0,0,0,4.16-1.37,5.36,5.36,0,0,0,1.78-3.62h9a14.36,14.36,0,0,1-4.95,9.86,15.84,15.84,0,0,1-10.8,3.87,15.09,15.09,0,0,1-11.43-4.62,17.81,17.81,0,0,1,.2-23.69q4.6-4.64,12.08-4.63a16.36,16.36,0,0,1,10.4,3.21,10,10,0,0,1,4.09,8.22,6.49,6.49,0,0,1-.49,2.56Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M996.72,153.64l13-31.49h8.5l12.92,31.49H1020.8l-1.53-4.36h-10.62l-1.58,4.36Zm19.71-12.32-2.43-6.89-2.47,6.89Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1035.38,122.15h6.21l14.35,15v-15h9.27v31.49h-6.52l-14.09-15v15h-9.22Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1071,153.64v-5.21l13-18.32h-12.78v-8h26.32v5.22l-13,18.26h13.27v8Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1101.75,153.64l13-31.49h8.51l12.91,31.49h-10.35l-1.53-4.36h-10.61l-1.58,4.36Zm19.71-12.32-2.43-6.89-2.47,6.89Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1140.41,122.15h13.72a16.84,16.84,0,0,1,12,4.43,14.88,14.88,0,0,1,4.7,11.32,14.68,14.68,0,0,1-4.79,11.38,17.09,17.09,0,0,1-11.95,4.36h-13.72Zm13.72,23.48a6.81,6.81,0,0,0,5.2-2.18,7.8,7.8,0,0,0,2.05-5.55,7.91,7.91,0,0,0-2.05-5.61,6.85,6.85,0,0,0-5.2-2.18h-4.23v15.52Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1179.42,126.06a17.15,17.15,0,0,1,23.44,0,17.55,17.55,0,0,1,0,23.67,17.12,17.12,0,0,1-23.44,0,17.55,17.55,0,0,1,0-23.67Zm6.82,17.39a6.17,6.17,0,0,0,4.88,2.18,6.24,6.24,0,0,0,4.9-2.18,8.92,8.92,0,0,0,0-11.11,6.24,6.24,0,0,0-4.9-2.18,6.17,6.17,0,0,0-4.88,2.18,9,9,0,0,0,0,11.11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObj100);
export default __webpack_public_path__ + "static/media/Obj_100.9c40d455b446bacdc38c8cd1d4cebf66.svg";
export { ForwardRef as ReactComponent };